import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  element: React.ReactElement;
}

const ProtectedRoute = ({ element }: ProtectedRouteProps) => {
  const location = useLocation();
  const token    = localStorage.getItem('access_token');
  return token ? element : <Navigate to="/login" state={{ from: location.pathname }} replace />;
};

export default ProtectedRoute;